






import { defineComponent } from '@vue/composition-api'

export default defineComponent({
    name: "HeadingAtom",
    props: {
        error: {
            type: String
        }
    }
})
